import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiFileText, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';

const InstitutionTemplateContent: React.FC = () => {
  const { t } = useTranslation();

  const requiredFields = [
    { key: 'tenantName', label: t('institutions.required_fields.tenantName'), required: true },
    { key: 'industry', label: t('institutions.required_fields.industry'), required: true },
    { key: 'contactInfo', label: t('institutions.required_fields.contactInfo'), required: true },
    { key: 'firstName', label: t('institutions.required_fields.firstName'), required: true },
    { key: 'lastName', label: t('institutions.required_fields.lastName'), required: true },
    { key: 'username', label: t('institutions.required_fields.username'), required: true },
    { key: 'email', label: t('institutions.required_fields.email'), required: true },
    { key: 'address', label: t('institutions.required_fields.address'), required: true },
    { key: 'phone', label: t('institutions.required_fields.phone'), required: true },
    { key: 'password', label: t('institutions.required_fields.password'), required: true }
  ];

  return (
    <div className="institution-template-content">
      <div className="template-header mb-3">
        <h6 className="text-primary d-flex align-items-center">
          <FiFileText className="me-2" />
          {t('institutions.template_requirements')}
        </h6>
      </div>

      <div className="template-fields mb-3">
        <div className="row">
          <div className="col-md-6">
            <h6 className="text-success mb-2">
              <FiCheckCircle className="me-1" />
              Required Fields 
            </h6>
            <ul className="list-unstyled">
              {requiredFields.filter(field => field.required).map((field, index) => (
                <li key={index} className="mb-1">
                  <span className="badge bg-danger me-2">*</span>
                  <strong>{field.key}:</strong> {field.label}
                </li>
              ))}
            </ul>
          </div>
          <div className="col-md-6">
            <h6 className="text-info mb-2">
              <FiFileText className="me-1" />
              Optional Fields
            </h6>
            <p className="text-muted">
              {t('institutions.no_optional_fields')}
            </p>
            
          </div>
        </div>
      </div>

      <div className="template-example mb-3">
        <h6 className="text-warning mb-2">
          <FiAlertCircle className="me-1" />
          Example Data Structure
        </h6>
        <div className="table-responsive">
          <table className="table table-sm table-bordered">
            <thead className="table-light">
              <tr>
                <th>tenantName</th>
                <th>industry</th>
                <th>contactInfo</th>
                <th>firstName</th>
                <th>lastName</th>
                <th>username</th>
                <th>email</th>
                <th>address</th>
                <th>phone</th>
                <th>password</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Test Corporation</td>
                <td>Technology</td>
                <td>contact@testcorp.com</td>
                <td>John</td>
                <td>Doe</td>
                <td>johndoe</td>
                <td>john.doe@testcorp.com</td>
                <td>123 Main Street, Cairo</td>
                <td>01234567890</td>
                <td>TestPass123!</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    

      <div className="template-tips mt-3">
        <h6 className="text-primary">Tips for Successful Upload:</h6>
        <ul className="list-unstyled">
          <li className="mb-1">
            <FiCheckCircle className="text-success me-2" />
            {t('institutions.tips.ensure_all_required_fields_are_filled')}
          </li>
          <li className="mb-1">
            <FiCheckCircle className="text-success me-2" />
            {t('institutions.tips.use_proper_email_format_for_email_fields')}
          </li>
          <li className="mb-1">
            <FiCheckCircle className="text-success me-2" />
            Passwords must be at least 8 characters and include: uppercase letter, lowercase letter, number, and symbol (e.g., TestPass123!)
          </li>
          <li className="mb-1">
            <FiCheckCircle className="text-success me-2" />
            {t('institutions.tips.avoid_special_characters_in_usernames')}
          </li>
          <li className="mb-1">
            <FiCheckCircle className="text-success me-2" />
            Phone numbers should be 10-15 digits (e.g., 01234567890 or +201234567890)
          </li>
          <li className="mb-1">
            <FiCheckCircle className="text-success me-2" />
            {t('institutions.tips.save_file_as_xlsx_or_xls_format')}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default InstitutionTemplateContent; 